<template>
  <div>
    <div
      v-style:aspect-ratio="aspectRatio"
      class="skeleton"
    />
    <div class="p-2 space-y-2">
      <div class="h-4 w-20 skeleton" />
      <div class="h-5 w-30 skeleton" />
      <div class="h-2 w-14 py-1 skeleton" />
      <div class="h-4 w-16 skeleton" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { aspectRatio } = useProductCardMedia()
</script>
